import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'app-web-scrape-modal',
	templateUrl: './web-scrape-modal.component.html',
	styleUrls: ['./web-scrape-modal.component.scss']
})
export class WebScrapeModalComponent implements OnInit {
	@Input() componentData: any;
	@Output() output = new EventEmitter<any>();
	WrapperHeight = window.innerHeight * 0.9 - 140;
	backup;
	viewportWidth = 1200;

	constructor() {}

	ngOnInit() {
		this.viewportWidth = this.componentData.config.viewport_width ? this.componentData.config.viewport_width : this.viewportWidth;
		this.backup = {
			item_height: this.componentData.config.item_height,
			item_width: this.componentData.config.item_width,
			left_offset: this.componentData.config.parser.left_offset,
			top_offset: this.componentData.config.parser.top_offset
		};
	}

	updatePosition(event) {
		this.componentData.config.parser.left_offset = event.left;
		this.componentData.config.parser.top_offset = event.top;
	}

	updateResize(event) {
		this.componentData = event;
	}

	update() {
		this.output.emit({ method: 'update', data: this.componentData });
	}

	cancel() {
		this.componentData.config.item_height = this.backup.item_height;
		this.componentData.config.item_width = this.backup.item_width;
		this.componentData.config.parser.left_offset = this.backup.left_offset;
		this.componentData.config.parser.top_offset = this.backup.top_offset;
		this.output.emit({ method: 'cancel', data: this.componentData });
	}

	reset() {
		this.componentData.config.item_height = 100;
		this.componentData.config.item_width = 100;
		this.componentData.config.parser.left_offset = 0;
		this.componentData.config.parser.top_offset = 0;
	}
}
